import presidentService from '../services/presidentService';

export const fetchAllPresidents = async () => {
  const result = await presidentService.getAllPresidents();
  if (!result?.success) {
    const error = new Error(result?.message || 'Başkanlar alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data };
};

export const createPresident = async (payload) => {
  const result = await presidentService.createPresident(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Başkan oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updatePresident = async (payload) => {
  const result = await presidentService.updatePresident(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Başkan güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deletePresident = async (id) => {
  const result = await presidentService.deletePresident(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Başkan silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchPresidentById = async (id) => {
  const result = await presidentService.getPresidentById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Başkan bilgisi alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const reorderPresidents = async ({ pastPresidentIdsInOrder }) => {
  const result = await presidentService.reorderPresidents({ pastPresidentIdsInOrder });
  if (!result?.success) {
    const error = new Error(result?.message || 'Sıralama güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const uploadPresidentPhoto = async ({ pastPresidentId, file }) => {
  const result = await presidentService.uploadPresidentPhoto({ pastPresidentId, file });
  if (!result?.success) {
    const error = new Error(result?.message || 'Fotoğraf yüklenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export default {
  fetchAllPresidents,
  createPresident,
  updatePresident,
  deletePresident,
  fetchPresidentById,
  reorderPresidents,
  uploadPresidentPhoto,
};


